<template>
  <v-form ref="form" fast-fail @submit.prevent>
    <Modal
      v-if="isOpened"
      id="create-filter-modal"
      :is-open="isOpened"
      :title="
        false
          ? labels.CUSTOM_METRIC.DIALOG_TITLE_EDIT
          : labels.CUSTOM_METRIC.CUSTOM_METRIC_FILTER_TITLE_NEW
      "
      :header-color="CONSTANTS.DIALOGS_HEADER_color"
      :card-actions-enabled="true"
      :disable-close="!isViewMode"
      @close-dialog="cancel"
    >
      <template #body>
        <v-row>
          <v-col cols="12">
            <expression-input
              v-if="query?.filter"
              :expression="query?.filter"
              :suggestions="tools"
              @fetch-tools="(targetUUID: string) => emit('targetSelected', targetUUID)"
              @selected-tool="
                (tool: Tool, location: string) =>
                  query ? emit('selectedTool', query, tool, location) : {}
              "
            ></expression-input>
          </v-col>
        </v-row>
      </template>

      <template #btn-group>
        <v-row v-if="!props.isViewMode" class="justify-center my-5">
          <v-col cols="auto">
            <v-btn-group class="btn-group">
              <v-btn class="secondary-btn" variant="flat" @click="cancel">
                {{ labels.CUSTOM_METRIC.CANCEL }}
              </v-btn>
            </v-btn-group>
          </v-col>

          <v-col cols="auto">
            <v-btn-group class="btn-group">
              <v-btn type="submit" class="primary-btn" variant="flat" @click="saveFilter">
                {{ labels.CUSTOM_METRIC.SAVE }}
              </v-btn>
            </v-btn-group>
          </v-col>
        </v-row>
      </template>
    </Modal>
  </v-form>
</template>

<script setup lang="ts">
  import CONSTANTS from '@/constants/Config.constants'
  import labels from '@/translations/labels.json'
  import Modal from '@/components/Modal/Modal.vue'
  import { computed, ComputedRef, ref } from 'vue'
  import { VForm } from 'vuetify/lib/components/index.mjs'
  import { CustomMetric, Filter, Query, Tool } from '@/models/custom-metric.model'
  import { useProjectStore } from '@/stores/projectStore'
  import { storeToRefs } from 'pinia'
  import { EventBus } from '@/event-bus'
  import ExpressionInput from './ExpressionInput.vue'

  interface Props {
    isOpened: boolean
    query: Query | undefined
    tools: Tool[]
    isViewMode: boolean
  }

  const props = defineProps<Props>()

  const emit = defineEmits<{
    closeDialog: [filter: Filter | undefined]
    disableViewMode: [value: boolean]
    selectedTool: [query: Query, tool: Tool, location: string]
    targetSelected: [targetUUID: string]
  }>()

  const initialFilter: ComputedRef<Filter | undefined> = computed(() => {
    if (!props.isOpened) {
      return undefined
    }
    if (initialFilter.value) {
      return initialFilter.value
    } else {
      return props.query?.filter
    }
  })
  const form = ref<VForm | null>(null)

  const projectStore = useProjectStore()
  const { currentProject } = storeToRefs(projectStore)

  async function saveFilter(): Promise<CustomMetric | undefined> {
    if (!currentProject?.value || !form.value || !props.query) return

    const result = await form.value.validate()
    if (!result.valid) return

    EventBus.emit('updateCustomMetricQueryInModal', props.query)
    EventBus.emit('reloadCustomMetricsPreviewData', props.query)
    emit('closeDialog', props.query.filter)
  }

  function cancel(): void {
    emit('closeDialog', initialFilter.value)
  }
</script>
